import {styled} from '@mui/material/styles'
import Select from '@mui/material/Select'
import Avatar from '@mui/material/Avatar'
import TextField from '@mui/material/TextField'
import {StyledDialogContent} from '../../../AdminPanel/UserManagement/RemoveUser/RemoveUserStyles'
import IconButton from '@mui/material/IconButton'
import {Box, Typography, Radio, FormControlLabel, Checkbox, MenuItem, ListItemText, Popover} from '@mui/material'
import {LockOutlined} from '@mui/icons-material'
const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  zIndex: 0,
  alignItems: 'center'
}))

const StyledSelect = styled(Select)(({theme}) => ({
  background: theme.palette.hpWhite,
  height: '32px',
  width: '190px',
  borderRadius: '4px',
  border: `1px solid rgba(0,0,0,0.2)`,
  color: theme.palette.hpAccentBlack,
  maxWidth: '350px',
  paddingLeft: '10px',
  fontSize: theme.typography.subtitle1.fontSize,
  '&.Mui-focused': {
    border: `2px solid ${theme.palette.hpAccentBlack}`
  },
  '&:hover': {
    border: `1px solid ${theme.palette.hpAccentBlack}`
  }
}))

const Legend = styled(Avatar)(({theme}) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  [`& .img`]: {
    backgroundColor: 'transparent',
    objectFit: 'Contain',
    height: theme.spacing(3.5),
    width: theme.spacing(3.5)
  }
}))

const StyledTextField = styled(TextField)(({theme}) => ({
  background: theme.palette.hpWhite,
  height: '32px',
  minWidth: '90px',
  width: 'auto',
  borderRadius: '4px',
  '&.Mui-focused': {
    borderColor: theme.palette.hpPrimary
  },
  '&:hover': {
    borderColor: theme.palette.hpPrimary
  }
}))

const StyledText = styled('p')(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpAccentBlack
}))

const StyledDialog = styled(StyledDialogContent)(() => ({
  padding: '40px'
}))

const StyledIconDiv = styled('div')(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

const StyledBodyDiv = styled(StyledDiv)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpAccentBlack
}))
const StyledIconButton = styled(IconButton)(({theme}) => ({
  padding: theme.spacing(0),
  marginRight: theme.spacing(3),
  float: 'right'
}))
const StyledSectionDividerLine = styled('div')(({theme}) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  width: '100%',
  border: `1px solid ${theme.palette.grey[200]}`
}))

const StyledBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'isOpen'})(({isOpen, theme}) => ({
  boxShadow: theme.shadows[2],
  width: '53.6px',
  height: '50.4px',
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.hpWhite,
  backgroundColor: isOpen ? theme.palette.hpPrimaryDark : theme.palette.hpWhite,
  color: isOpen ? theme.palette.hpWhite : theme.palette.hpPrimaryDark,
  '& svg': {
    color: isOpen ? theme.palette.hpWhite : theme.palette.hpPrimaryDark,
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: theme.spacing(1),
    flexDirection: 'column'
  },
  '& span': {
    color: isOpen ? theme.palette.hpWhite : theme.palette.hpAccentBlack
  },
  '&:focus': {border: `1px solid ${theme.palette.hpPrimary}`},
  '&:hover': {border: `1px solid ${theme.palette.hpPrimary}`}
}))

const StyledRadioButton = styled(Radio)(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  padding: '0px 4px 0px 0px',
  '&.Mui-checked': {
    color: theme.palette.hpPrimaryDark
  },
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.h6.fontSize
  }
}))

const StyledTypographyForMenu = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  fontWeight: theme.typography.fontWeightSemibold,
  paddingLeft: theme.spacing(0.5),
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none'
}))

const StyledBoldLabel = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.subtitle1.fontSize
}))

const StyledFormControlLabel = styled(FormControlLabel)(({theme}) => ({
  margin: theme.spacing(0),
  '& .MuiFormControlLabel-label': {
    color: theme.palette.hpAccentBlack,
    fontSize: theme.typography.subtitle1.fontSize
  }
}))

const StyledSpan = styled('span')(({theme}) => ({
  marginBottom: theme.spacing(1.5),
  lineHeight: '14px',
  fontSize: theme.typography.listItemSmall.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  // Below part is to prevent accidental text selection on the span element
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none'
}))

const StyledDivContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}))

const StyledCheckBox = styled(Checkbox)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize,
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.h6.fontSize
  }
}))

const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  padding: theme.spacing(0.5),
  marginLeft: theme.spacing(-1.25),
  height: '35px'
}))

const StyledStack = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}))

const StyledListItemText = styled(ListItemText)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpBlack,
  maxWidth: '185px',
  textWrap: 'wrap',
  wordBreak: 'break-word',
  lineHeight: '16px'
}))

const StyledOffBadge = styled('span')(({theme}) => ({
  position: 'absolute',
  right: theme.spacing(-1.5),
  color: `${theme.palette.hpAccentRed} !important`,
  background: theme.palette.hpWhite,
  fontSize: theme.typography.labelSmall.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.125),
  lineHeight: theme.spacing(2),
  zIndex: 2
}))

const StyledIconContainer = styled('div')(() => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

const StyledLockIcon = styled(LockOutlined)(({theme}) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  fontSize: `${theme.typography.labelMedium.fontSize} !important`,
  color: `${theme.palette.hpWhite} !important`,
  width: `${theme.spacing(1.5)} !important`,
  height: `${theme.spacing(1.5)} !important`,
  marginTop: `${theme.spacing(0.25)} !important`,
  marginRight: `${theme.spacing(0.25)} !important`
}))

const StyledLockBadge = styled(Box)(({theme}) => ({
  width: '18px',
  height: '18px',
  backgroundColor: theme.palette.hpOrangeDark,
  position: 'absolute',
  margin: '1px',
  borderTopRightRadius: '3px',
  borderBottomLeftRadius: '12px',
  right: 0,
  top: 0
}))

const StyledFocusPopover = styled(Popover)(({theme}) => ({
  pointerEvents: 'none',
  '& .MuiPaper-root': {
    paddingBottom: theme.spacing(2)
  },
  '&.MuiPopover-root': {
    zIndex: 10,
    width: '450px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const StyledFocusMessageText = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpAccentBlack,
  fontStyle: 'italic'
}))

export {
  StyledSelect,
  StyledDiv,
  Legend,
  StyledTextField,
  StyledText,
  StyledDialog,
  StyledIconDiv,
  StyledBodyDiv,
  StyledIconButton,
  StyledSectionDividerLine,
  StyledBox,
  StyledRadioButton,
  StyledTypographyForMenu,
  StyledBoldLabel,
  StyledSpan,
  StyledFormControlLabel,
  StyledStack,
  StyledCheckBox,
  StyledMenuItem,
  StyledListItemText,
  StyledOffBadge,
  StyledIconContainer,
  StyledDivContainer,
  StyledLockIcon,
  StyledLockBadge,
  StyledFocusPopover,
  StyledFocusMessageText
}
